import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import { FaFileCsv, FaLock, FaCalendarAlt, FaShieldAlt } from "react-icons/fa";
import './PersonalData.scss';

export default function PersonalDataComponent({ isMobile, mainProps, showSidebar }) {
    const navigate = useNavigate();
    const { main, mainLoading, mainError } = mainProps;
    const [showPhone, setShowPhone] = useState(false);
    const [maskedPhone, setMaskedPhone] = useState('');

    const phoneNo = main?.user?.detail?.otp_phone_nr || "";

    const handleClick = (section) => {
        toast.success(`Update data request for ${section} was sent to the bank representavies, you will get a call for update soon.`);
    }

    const escapeCSV = (value) => {
        if (typeof value !== 'string') return value ?? '';
        return `"${value.replace(/"/g, '""')}"`;
    };

    const exportCSV = () => {
        const data = [
            ['First Name', 'Last Name', 'Account Number', 'IBAN', 'Mobile Phone'],
            [
                escapeCSV(main?.user?.first_name || ''),
                escapeCSV(main?.user?.last_name || ''),
                escapeCSV(main?.user?.detail?.account_number?.replace(/^.*?-/, '') || ''),
                escapeCSV(main?.user?.detail?.iban || ''),
                escapeCSV(phoneNo || '')
            ]
        ];

        const csvContent = data.map(row => row.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'My_Profile_Data.csv');
    };

    useEffect(() => {
        if (showPhone) {
            setMaskedPhone(phoneNo);
        } else {
            const masked = phoneNo.slice(0, -4).replace(/\d/g, '*') + phoneNo.slice(-4);
            setMaskedPhone(masked);
        }
    }, [showPhone, phoneNo]);

    return (
        <div
            className="container-fluid bg-col transition-width"
            style={!isMobile ? {
                width: showSidebar ? 'calc(100% - 332px)' : '100%',
                marginLeft: 0,
                marginRight: 'auto',
                transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
            } : {}}
        >
            <div className="row p-3 reports-panel mb-5">
                <h5 className="mb-5 mt-2">PERSONAL DATA</h5>
                <p className="text-muted">The information shown reflects your current bank account details on file. To make any updates, please contact a banking specialist and submit a formal request for changes.</p>

                <div className='row mt-2 m-auto' style={isMobile ? {} : { borderBottom: "2px solid #EFEFEF" }}>
                    <div className={`col-md-6 p-3 ${isMobile && "border"}`} style={{ borderRight: "2px solid #EFEFEF" }}>
                        <h5 className="fw-semibold mb-4">PERSONAL INFO</h5>

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <p className="text-muted">Your representative first name is: </p>
                            <p className="text-muted"><strong>{main?.user?.first_name}</strong></p>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <p className="text-muted">Your representative last name is: </p>
                            <p className="text-muted"><strong>{main?.user?.last_name}</strong></p>
                        </div>


                        <div className={`mt-5 ${isMobile ? "text-center" : "text-end"}`}>
                            <button className='btn rounded-pill balaneCustom-bg-secondary' onClick={() => handleClick('PERSONAL INFO')}>UPDATE</button>
                        </div>
                    </div>

                    <div className={`col-md-6 p-3 d-flex flex-column ${isMobile && "border"} margin-mobile`}>
                        <h5 className="fw-semibold mb-4">CELLULAR</h5>

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <p className="text-muted">Your mobile number is:</p>
                            <p className="text-muted" onClick={() => setShowPhone(!showPhone)}>
                                <strong>{maskedPhone}</strong>
                            </p>
                        </div>

                        <div className={`mt-auto ${isMobile ? "text-center" : "text-end"}`}>
                            <button className='btn rounded-pill balaneCustom-bg-secondary' onClick={() => handleClick('CELLULAR')}>UPDATE</button>
                        </div>
                    </div>

                </div>

                <div className='row mb-5 mt-4 m-auto' style={isMobile ? {} : { borderBottom: "2px solid #EFEFEF" }}>

                    <div className={`col-md-6 p-3 ${isMobile && "border"}`} style={{ borderRight: "2px solid #EFEFEF" }}>
                        <h5 className="fw-semibold mb-4">BANKING ACCOUNT</h5>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <p className="text-muted">Your account number is: </p>
                            <p className="text-muted"><strong>{main?.user?.detail?.account_number?.replace(/^.*?-/, '')}</strong></p>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <p className="text-muted">Your IBAN is: </p>
                            <p className="text-muted"><strong>{main?.user?.detail?.iban}</strong></p>
                        </div>

                    </div>

                    <div className={`col-md-6 p-3 ${isMobile && "border"} margin-mobile`}>
                        <h5 className="fw-semibold mb-4">SUMMARY OF PERSONAL DATA</h5>

                        <div className="d-flex justify-content-between align-items-center">
                            <svg
                                className="drop-shadow-lg"
                                width="200"
                                height="160"
                                viewBox="0 0 200 160"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect x="20" y="10" width="120" height="90" rx="8" fill="#f8fafc" stroke="#1E266D" strokeWidth="3" />
                                <rect x="35" y="25" width="90" height="4" rx="2" fill="#e2e8f0" />
                                <rect x="35" y="35" width="70" height="4" rx="2" fill="#e2e8f0" />
                                <rect x="35" y="45" width="85" height="4" rx="2" fill="#e2e8f0" />
                                <circle cx="100" cy="70" r="15" fill="none" stroke="#6b7280" strokeWidth="2" />
                                <circle cx="100" cy="70" r="8" fill="#6A343A" />
                                <rect x="10" y="70" width="60" height="90" rx="12" fill="#ffffff" stroke="#1E266D" strokeWidth="3" />
                                <rect x="18" y="85" width="44" height="60" rx="4" fill="#f1f5f9" />
                                <circle cx="40" cy="155" r="4" fill="#cbd5e1" />
                                <rect x="25" y="92" width="30" height="3" rx="1.5" fill="#6A343A" />
                                <rect x="25" y="100" width="25" height="3" rx="1.5" fill="#e2e8f0" />
                                <rect x="25" y="108" width="28" height="3" rx="1.5" fill="#e2e8f0" />
                                <rect x="120" y="90" width="70" height="50" rx="8" fill="#ffffff" stroke="#1E266D" strokeWidth="3" />
                                <path d="M130 105 L155 120 L180 105" stroke="#6A343A" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                <rect x="130" y="105" width="50" height="25" fill="none" stroke="#6A343A" strokeWidth="2" rx="2" />
                                <circle cx="160" cy="30" r="2" fill="#6A343A" opacity="0.8" />
                                <circle cx="170" cy="25" r="1.5" fill="#1E266D" opacity="0.6" />
                                <circle cx="30" cy="45" r="1.5" fill="#6A343A" opacity="0.6" />
                                <path d="M70 115 Q90 110 120 115" stroke="#1E266D" strokeWidth="2" fill="none" strokeDasharray="4 4" opacity="0.6" />
                            </svg>

                            <p className="text-muted">
                                If you want to download the data we have, you can click below: Download CSV
                            </p>
                        </div>

                        <div className={`mt-5 ${isMobile ? "text-center" : "text-end"}`} onClick={exportCSV}>
                            <button className='btn rounded-pill balaneCustom-bg-secondary'>
                                <FaFileCsv style={{ fontSize: '30px' }} /> Download CSV
                            </button>
                        </div>
                    </div>
                </div>

                {isMobile && (
                    <section className="d-block d-md-none mt-4 px-3 pb-5">
                        <h5 className="text-muted fw-semibold mb-4">You may also need to manage:</h5>
                        <div className="d-grid gap-3">
                            <div
                                onClick={() => navigate("/passwords")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaLock size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">Passwords</span>
                            </div>

                            <div
                                onClick={() => navigate("/calendar-appointments")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaCalendarAlt size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">My Calendar</span>
                            </div>

                            <div
                                onClick={() => navigate("/privacy-and-consent")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaShieldAlt size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">Privacy and Consent</span>
                            </div>
                        </div>
                    </section>
                )}

            </div>
        </div >
    );
}